
import { Component, Prop, Vue, Model, Emit} from "vue-property-decorator";

@Component
export default class McFgInput extends Vue {
    @Prop({default: ""}) readonly mcLabel!: string
    @Prop({default: "CountType"}) readonly countType!: string
    @Prop({default: false}) public isReadOnly!: boolean
    @Prop({default: null}) public theState!: boolean
    @Prop({default: 0}) public min!: number
    @Prop({default: 1}) public countIncrement!: number

    @Model('change', {type:Object}) count!: {[k: string]:any}

    incrementInput(value: number){
        this.count[this.countType] += this.countIncrement;
        this.inputChanged() // we have to do this, since the change method can't apply to a readonly input
    }
    decrementInput(value: number){
        if (this.count[this.countType] > this.min) this.count[this.countType] = Math.max(this.min, this.count[this.countType] - this.countIncrement);
        this.inputChanged() // we have to do this, since the change method can't apply to a readonly input
    }

  keyup() {
    const value = this.count[this.countType];
    if (this.min < 0 && value < this.min) {
      this.count[this.countType] = this.min;
    }

    if (this.min >= 0) {

      this.count[this.countType] = Math.abs(Math.round(value));
    }
  }

    @Emit('input-changed')
    inputChanged(){
        // We don't need to do anything, only emit the input-changed event
    }
}
